import {
  emptyNodeDataObject,
  updateDeleteIconActiveState,
  updateEditStructurePageInitialData,
  updateEditStructurePageInitialDataFiltered,
  updateEditStructurePageTransferData,
  updateEditStructurePageTransferDataFiltered,
  updateNodeSelectionNodeData,
  updateNodeSelectionNodeEditedState,
  updateNodeSelectionState,
  updateStructureWasSaved,
} from "@src/reducers/your-reducer";
import store from "@src/reducers/store";
import { getInitialStructureNodeset } from "../dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "../dependency-injection-container/get-machine-structure-nodeset";

const clearNewStructure = () => {
  store.dispatch(updateEditStructurePageTransferData(undefined));
  store.dispatch(updateEditStructurePageInitialData(undefined));
  store.dispatch(updateEditStructurePageInitialDataFiltered(undefined));
  store.dispatch(updateEditStructurePageTransferDataFiltered(undefined));

  const initialStructureNodeset = getInitialStructureNodeset();
  initialStructureNodeset.clear();
  const machineStructureNodeset = getMachineStructureNodeset();
  machineStructureNodeset.clear();

  store.dispatch(updateNodeSelectionState("none"));
  store.dispatch(updateNodeSelectionNodeData(emptyNodeDataObject));
  store.dispatch(updateNodeSelectionNodeEditedState(false));

  store.dispatch(updateDeleteIconActiveState(false));

  store.dispatch(updateStructureWasSaved(true));
};

const clearInitialAndMachineStructure = () => {
  clearNewStructure();
};

export default clearInitialAndMachineStructure;
